"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Filter_1 = require("./Filter");
const FilterListItem_1 = require("./FilterListItem");
class FilterList extends Array {
    constructor() {
        super(...arguments);
        this.getOrdered = () => this.sort((x, y) => (x.order > y.order ? 1 : -1));
        this.updateFilter = (filter, filterListItem) => {
            const itemToReplace = filterListItem.selectionType === FilterListItem_1.SelectionType.MULTIPLE ? filterListItem : this.clearFiltersFromItem(filterListItem);
            const newFilterListItem = new FilterListItem_1.FilterListItem(itemToReplace.type, itemToReplace.order, itemToReplace.header, itemToReplace.name, itemToReplace.value, itemToReplace.selectionType, [...itemToReplace.filter(x => x.order !== filter.order && x.name !== filter.name), filter]);
            return this.copyFromArray([
                ...this.filter(x => x.order !== newFilterListItem.order && x.name !== newFilterListItem.name),
                newFilterListItem
            ]);
        };
        this.clearFiltersFromItem = (filterListItem) => new FilterListItem_1.FilterListItem(filterListItem.type, filterListItem.order, filterListItem.header, filterListItem.name, filterListItem.value, filterListItem.selectionType, [...filterListItem].map(filter => new Filter_1.Filter(Object.assign(Object.assign({}, filter), { isSelected: false }))));
        this.clearFilters = () => this.copyFromArray(this.map(x => this.clearFiltersFromItem(x)));
    }
}
exports.default = FilterList;
//# sourceMappingURL=FilterList.js.map